import {Component, ViewChild} from '@angular/core';
import {ViewController} from 'ionic-angular';
import {SessionService} from '../../../../services/session';

@Component({
  selector: 'page-camera',
  templateUrl: 'camera.html'
})
export class CameraPage {
  @ViewChild('videoElement') videoElement: any;
  @ViewChild('canvas') canvas: any;

  constructor(public viewCtrl: ViewController,
              public sessionService: SessionService) {

  }

  displayControls = true;
  photo: any;
  track: any;

  ionViewDidLoad() {
    this.start();
  }

  ionViewWillLeave() {
    this.track.stop();
  }

  start() {
    this.initCamera({video: true, audio: false});
  }

  sound() {
    this.initCamera({video: true, audio: true});
  }

  initCamera(config: any) {
    var browser = <any>navigator;

    browser.getUserMedia = (browser.getUserMedia ||
      browser.webkitGetUserMedia ||
      browser.mozGetUserMedia ||
      browser.msGetUserMedia);
    console.log('browser is: ', browser)
    browser.mediaDevices.getUserMedia(config).then(stream => {
      this.track = stream.getTracks()[0];
      this.videoElement.nativeElement.src = window.URL.createObjectURL(stream);
      this.videoElement.nativeElement.play();
    }).catch(err => {
      this.sessionService.reportError(
        'cameraPage',
        'initCamera()',
        err
      );
    });
  }

  toggleControls() {
    this.videoElement.nativeElement.controls = this.displayControls;
    this.displayControls = !this.displayControls;
  }

  resume() {
    this.videoElement.nativeElement.play();
  }

  onTakePic() {
    // var context = this.canvas.nativeElement.getContext('2d')
    // .drawImage(this.videoElement.nativeElement, 0, 0, 640, 480);
    this.photo = this.canvas.nativeElement.toDataURL('image/png');
    this.closeCamera()
  }

  closeCamera() {
    this.viewCtrl.dismiss(this.photo);
  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/shared/camera/camera.ts